<template>
  <div class="text-end mb-3">
    <button
      class="btn btn-primary"
      title="Exportar para Excel"
      @click="exportToExcel"
    >
      Exportar para Excel
    </button>
  </div>
  <div class="card">
    <div class="table-responsive">
      <table
        class="table table-sm table-bordered table-striped"
        id="tableReport"
      >
        <thead class="bg-teal text-white text-center">
          <tr>
            <th>Tipo</th>
            <th>Chave do Centro de Custo</th>
            <th>Chave da Ação</th>
            <th>Cod. Reduzido Conta</th>
            <th>Cod. Reduzido Natureza</th>
            <th>Mes</th>
            <th>Unidade</th>
            <th>Descrição do Lançamento</th>
            <th>Qtd. Pessoas</th>
            <th>Qtd. Dias</th>
            <th>Qtd. Unidade</th>
            <th>Valor Unitário</th>
            <th>Valor Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(registro, index) in reports" :key="index">
            <td class="fs-smxs">{{ registro.tipo }}</td>
            <td class="fs-smxs">{{ registro.chaveCentroCusto }}</td>
            <td class="fs-smxs">{{ registro.chaveAcao }}</td>
            <td class="fs-smxs">{{ registro.codReduzidoConta }}</td>
            <td class="fs-smxs">{{ registro.codReduzidoNatureza }}</td>
            <td class="fs-smxs">{{ registro.mes }}</td>
            <td class="fs-smxs">{{ registro.unidade }}</td>
            <td class="fs-smxs">{{ registro.descricaoLancamento }}</td>
            <td class="fs-smxs">{{ registro.qtdPessoas }}</td>
            <td class="fs-smxs">{{ registro.qtdDias }}</td>
            <td class="fs-smxs">{{ registro.qtdUnidade }}</td>
            <td class="fs-smxs text-center">
              {{ moneyToCurrencyBr(registro.valorUnitario) }}
            </td>
            <td class="fs-smxs text-center">
              {{ moneyToCurrencyBr(registro.valorTotal) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { moneyToCurrencyBr } from '@/utils/strings'
import '@/assets/js/jquery.table2excel'

export default {
  name: 'ImportacaoSistegoResult',

  props: {
    reports: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      moneyToCurrencyBr,
    }
  },

  methods: {
    exportToExcel() {
      window.$('#tableReport').table2excel({
        name: 'ImportacaoSistego',
        filename: 'Relatorio_SGCC_ImportacaoSISTEGO.xls',
      })
    },
  },
}
</script>

<style scoped>
td {
  padding: 0.3rem;
}
</style>
